<template>
    <div class="wrapper">
        <h2 class="page_title">{{ $t("page.bitrix24.mainheader") }}</h2>
        <div class="container_block">
            <OrderedListRecurring :list="instruction.map(({ text }) => text)">
                <template v-slot:default="props">
                    <img
                        :src="instruction[props.index].img"
                        class="image_list"
                    />
                </template>
            </OrderedListRecurring>
            <BaseCardInstruction
                class="card_block"
                :text="$t('page.bitrix24.text1')"
                :buttonText="$t('common.instruction')"
                @clickButton="onClickInstructions"
            />
        </div>
    </div>
</template>

<script>
import OrderedListRecurring from "@/components/Recurring/OrderedListRecurring.vue";
import BaseCardInstruction from "@/components/Instruction/BaseCardInstruction.vue";
// Images
import bitrixUA from "@/assets/bitrix24/bitrixUA.png";
import bitrixUAtwo from "@/assets/bitrix24/bitrixUAtwo.png";
import bitrixUAthree from "@/assets/bitrix24/bitrixUAthree.png";

export default {
    components: {
        OrderedListRecurring,
        BaseCardInstruction,
    },
    data() {
        return {
            instruction: [
                { text: "page.bitrix24.text2", img: bitrixUA },
                { text: "page.bitrix24.text3", img: bitrixUAtwo },
                { text: "page.bitrix24.text4", img: bitrixUAthree },
            ],
        };
    },
    methods: {
        onClickInstructions() {
            window.open(
                "https://sites.google.com/view/bitrix24-e-chat#h.kqmstof7ly8w"
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.card_block {
    max-width: 680px;
}

.image_list {
    margin: 15px 0;
    width: 100%;
    /* border-radius: 11px; */
}
</style>
